import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { SolicitareRankService } from '../solicitare-rank.service';
import { finalize } from 'rxjs';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { initializeEditor } from 'src/app/utils/angular-editor/editorConfig';
import { helper } from 'src/environments/helper';

@Component({
  selector: 'app-add-solicitare-rank',
  templateUrl: './add-solicitare-rank.component.html',
  styleUrls: ['./add-solicitare-rank.component.scss']
})
export class AddSolicitareRankComponent implements OnInit {
  // general error
  errorTitle: string = environment.config.customNotifications.headers.error;
  errorIcon: string = environment.config.customNotifications.icons.error;
  errorType: string = environment.config.customNotifications.icons.error;
  helper = helper;

  editorConfig!: AngularEditorConfig;

  token!: string;
  isLoading = false;
  form: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required]),
    slug: new FormControl('', [Validators.required]),
    color: new FormControl('', [Validators.required]),
  });

  constructor(
    private dialogRef: MatDialogRef<AddSolicitareRankComponent>,
    private solicitareRankService: SolicitareRankService,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {
    this.processToken();
  }

  ngOnInit(): void {
    this.editorConfig = initializeEditor();
  }

  closeDialog() {
    this.dialogRef?.close({
      success: false,
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token;
      this.solicitareRankService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const sablon = {
      name: this.form.get('name')?.value,
      slug: this.form.get('slug')?.value,
      color: this.form.get('color')?.value,
    };

    this.solicitareRankService
      .addSolicitareRank(sablon)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (res) => {
          this.dialogRef.close({ success: true });
        },
        error: (err) => {
          let errorMessage =
            environment.config.customNotifications.generalMessages.error;
          this.notificationService.warningSwal(
            this.errorTitle,
            errorMessage,
            this.errorIcon
          );
        },
      });
  }

}
